export function isEditableRange(element, range) {
  return Boolean(element?.isConnected && range && range.startContainer.isConnected && range.endContainer.isConnected
    && element.contains(range.startContainer) && element.contains(range.endContainer));
}

export function editableRange(element) {
  const selection = element?.ownerDocument.defaultView.getSelection();
  const range = selection?.rangeCount ? selection.getRangeAt(0) : null;
  return isEditableRange(element, range) ? range.cloneRange() : null;
}

// Jodit must never insert its text markers into a detached range or the Document itself.
export function ensureEditableSelection(element, fallback = null, restore = false) {
  if (!element?.isConnected) return null;
  const selection = element.ownerDocument.defaultView.getSelection();
  if (!selection) return null;
  const current = editableRange(element);
  if (current && !restore) return current;
  const range = isEditableRange(element, fallback) ? fallback.cloneRange() : current || element.ownerDocument.createRange();
  if (!isEditableRange(element, range)) { range.selectNodeContents(element); range.collapse(false); }
  selection.removeAllRanges();
  selection.addRange(range);
  return range.cloneRange();
}
